import { css } from 'lit';

export const styles = css`
	:host {
		display: block;
		width: 100%;
	}
	.base-bar {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		align-items: center;
		z-index: 100;
		background-color: transparent;
		gap: var(--spacing-md);
		padding: var(--spacing-md) 0;
		box-sizing: border-box;
	}

	.left,
	.center,
	.right {
		display: flex;
		flex: 1;
		gap: var(--spacing-sm);
	}

	.left {
		display: flex;
		justify-content: flex-start;
		gap: var(--spacing-sm);
	}

	.right {
		justify-content: flex-end;
	}

	.center {
		flex: 1 1 0;
		justify-content: center;
	}

	.search-bar {
		width: 100%;
	}

	studio-input::part(input-container) {
		width: 100%;
	}
	
	.info {
		cursor: pointer;
		display: grid;
		justify-content: center;
	}

	.view-switcher {
		display: flex;
		align-items: center;
		gap: 0;
	}

	.filter-select {
		width: 100%;
		display: flex;
		// justify-content: flex-end;
		align-items: anchor-center;
	}

	.sort-select {
		display: flex;
		gap: 0.25rem;
	}

	.sort-select > studio-button-group {
		display: flex;
		align-items: center;
	}

	:host(.sticky) {
		position: sticky;
		top: 0;
		left: 0;
		width: inherit;
		z-index: 100;
		background-color: var(--surface-base);
	}

	@media (max-width: 1024px) {
		.base-bar {
			flex-direction: column;
    		align-items: stretch;
			padding: 0;
			margin: var(--spacing-md) 0;
		}
		.left,
		.center,
		.right {
			flex: unset;
			width: 100%;
			justify-content: stretch;
		}
		.right {
			flex-wrap: wrap;
			justify-content: space-between;
			gap: var(--spacing-md);
		}

		.sort-select > studio-button-group {
			display: inline-flex;
			justify-content: start;
			width: 100%;
			max-width: 400px;
		}
		:host(.sticky) {
			position: relative;
		}
		.sort-select {
			width: 100%;
		}
		.search-bar,
		.filter-select,
		.sort-select,
		.view-switcher {
			width: 100%;
			display: block;
		}
		.sort-select > studio-select {
			margin-bottom: var(--spacing-md);
		}
		.base-bar {
			padding: 0;
		}
	}
`;